<template>
	<div class="instrument">
		<h1 class="title">小器械训练</h1>
		<div class="items clear_both">
			<a v-for="v in list" :key="v.courseId" class="item" @click="handleItemClick(v)">
				<div class="video_wrap">
					<img :src="v.picOssUrl" alt="">
					<div class="mask"><i></i></div>
				</div>
				<p class="video_name text_one">{{ v.courseName }}</p>
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default() { return []; }
			}
		},
		methods: {
			/*************** @Events *******************/
			// 点击视频
			handleItemClick(obj) {
				this.$emit('onClick', obj.courseId);
			}
		}
	}
</script>

<style scoped>
	.instrument{ width: 1200px;margin: 30px auto 0;padding: 60px 150px 45px 150px;border-radius: 10px;background: #fff;overflow: hidden; }
	.instrument .title{ font-size: 30px;text-align: center;line-height: 42px; }
	.instrument .items{ margin-top: 35px; }
	.instrument .item{ display: block;float: left;width: 264px;margin: 0 54px 40px 0; }
	.instrument .item:nth-child(3n){ margin-right: 0; }
	.instrument .video_wrap{ position: relative;height: 167px;border-radius: 10px;overflow: hidden; }
	.instrument .video_wrap img{ display: block;width: 100%;height: 100%;transition: all .3s linear; }
	.instrument .video_wrap .mask{ position: absolute;width: 100%;height: 100%;top: 0;left: 0;background: rgba(0, 0, 0, 0.5);cursor: pointer; }
	.instrument .video_wrap .mask i{ display: block;position: absolute;width: 42px;height: 42px;top: 50%;left: 50%;margin: -21px 0 0 -21px;background-image: url(../../../../assets/video_play.png);background-size: 100% 100%; }
	.instrument .video_wrap:hover img{ transform: scale(1.2, 1.2); }
	.instrument .video_name{ font-size: 18px;color: #333;text-align: center;line-height: 42px; }
</style>
